import React, { useEffect, useState } from 'react';
import fileDownload from 'js-file-download';
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import { Invoice } from '../../_models/Invoice';
import { API } from 'aws-amplify';
import { getAPIName } from '../../config';
import { TopFormSearchOption } from '../TopFormSearch';
import TopForm, { TopFormState, StatusOption } from '../TopForm';
import handleApiErrors from '../../common/handleApiErrors';
import ReactTable, { Column, SortingRule } from 'react-table';
import { generateMailHref, generateEscalationMailHref } from '../../common/helper';
import moment from 'moment';
import ConfirmationModal from '../helpercomponent/confirmationModal'
import {
  CircularProgress,
  Button,
  Grid,
  Typography,
  Tooltip,
  Box,
} from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPencilAlt,
  faCircleExclamation,
  faPaperPlane,
  faExclamationCircle
} from '@fortawesome/free-solid-svg-icons';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { Auth } from "aws-amplify";
import EditInvoicePopup from '../EditInvoicePopup'
import { navigate } from '@reach/router';
import useCustomSnak from '../helpers/handleSnackbars';
import { RadioSearchOptions } from '../RadioForm';
// import AnnouncmentBanner from '../Announcment'
import GeneralisedConfirmationPopup from '../helpercomponent/generalised_confirmation_popup.tsx';
import { PaymentDetails } from '../PaymentDetails';
import { PAYMENT_LOGOS } from '../../common/utils';

const searchOptions: TopFormSearchOption[] = [
  { label: 'Contract', value: 'contract.contractnumber' },
  { label: 'RO#', value: 'contract.ro_number' },
  { label: 'Email', value: 'customer-email'},
  { label: 'Invoice No.', value:'id'}
  //{ label: 'License Plate', value: 'vehicle.licenseplate' },
];

const useButtonStyles = makeStyles((theme: Theme) =>
  createStyles({
    edit_bt: {
      float: 'right',
      minWidth: '25px',
      fontSize: '12px',
    },
    invoice_stat_div: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "space-between",
      textAlign: "left"
    },
    invoice_stat: {
      minWidth: "180px",
      margin: "auto"
    },
    paymentlink_reactivation :{
      background: "forestgreen",
      color: "white",
      '&:hover': { 
        backgroundColor: 'darkgreen',
      },
    },
    splitMailContainer: {
      position: 'relative',
      display: 'flex',
      width: '100%',
      height: 32,
      borderRadius: 6,
      overflow: 'hidden',
      background: '#f8f9fa',
      border: '1px solid #e9ecef',
      cursor: 'pointer',
    },
    mailSection: {
      position: 'relative',
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '4px 8px',
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      zIndex: 2,
      '&:hover $mailIcon': {
        color: 'white',
      },
    },
    mailContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all 0.3s ease',
      width: '100%',
      height: '100%',
    },
    mailIcon: {
      fontSize: 18,
      color: '#424243',
      transition: 'all 0.3s ease',
    },
    slideIndicator: {
      position: 'absolute',
      top: 0,
      left: '-50%',
      width: '50%',
      height: '100%',
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      zIndex: 1,
      opacity: 0,
    },
    regularSection: {
      '&:hover ~ $slideIndicator': {
        left: 0,
        opacity: 1,
        background: '#4CAF50',
      },
    },
    escalationSection: {
      '&:hover ~ $slideIndicator': {
        left: '50%',
        opacity: 1,
        background: '#f2b900',
      },
    },
  })
)



export const lmsLevelInvoiceStatusMapping: any = {
  "TSDv2" : {
    "Charged": "Charged",
    "Created": "Created",
    "Declined": "Declined",
    "missing_cc_token":  "Integrated Invoice Sent",
    "manually_charged": "Manually Charged",
    "customer_dispute_won": "Customer Dispute - Won",
    "customer_dispute_lost": "Customer Dispute - Lost",
    "customer_dispute_initiated": "Customer Dispute - Initiated",
    "manually_refunded": "Manually Refunded",
    "void": "Void",
    "integrated_invoice_sent": "Integrated Invoice Sent",
    "toll_exempt":"Toll Exempt",
    "already_processed": "Already Processed",
    "not_found": "Not Found",
    "other": "Other"
  }
}
export const statusOptions: StatusOption[] = [
  { name: 'Already Processed', value: 'already_processed'},
  { name: 'Charged', value: 'Charged' },
  { name: 'Created', value: 'Created' },
  { name: 'Declined', value: 'Declined' },
  { name: 'Customer Dispute - Lost', value: 'customer_dispute_lost' },
  { name: 'Customer Dispute - Won', value: 'customer_dispute_won' },
  { name: 'Customer Dispute - Initiated', value: 'customer_dispute_initiated' },
  { name: 'Integrated Invoice Sent', value: 'integrated_invoice_sent'},
  { name: 'Manually Refunded', value: 'manually_refunded' },
  { name: 'Missing Credit Card', value: 'missing_cc_token' },
  { name: 'Manually Charged', value: 'manually_charged' },
  { name: 'Not Found', value: 'not_found'},
  { name: 'Other', value: 'other'},
  { name: 'Toll Exempt', value: 'toll_exempt'},
  { name: 'Void', value: 'void' },
];
export const statusOptionsDict: any = {
  "Charged": "Charged",
  "Created": "Created",
  "Declined": "Declined",
  "missing_cc_token": "Missing Credit Card",
  "manually_charged": "Manually Charged",
  "customer_dispute_won": "Customer Dispute - Won",
  "customer_dispute_lost": "Customer Dispute - Lost",
  "customer_dispute_initiated": "Customer Dispute - Initiated",
  "manually_refunded": "Manually Refunded",
  "void": "Void",
  "integrated_invoice_sent": "Integrated Invoice Sent",
  "toll_exempt":"Toll Exempt",
  "already_processed": "Already Processed",
  "not_found": "Not Found",
  "other": "Other"
}
interface PageState {
  readonly page: number;
  readonly pageSize: number;
  readonly sortingRules: SortingRule[];
}
const defaultPageState: PageState = {
  page: 0,
  pageSize: 10,
  sortingRules: [{
    id: 'id',
    desc: true,
  }],
};

interface PendingUpdate {
  invoice: any;
  updated_status: string;
}

const timestampTypeSearchOption: RadioSearchOptions[] = [
    { label: 'Attempted Charge Time', value: 'attempted_charge_time' },
    { label: 'Inserted Time', value: 'inserted_timestamp' },
]
export default function Invoices() {
  const { enqueueSnackbar } = useSnackbar();
  const handleCustomSnak = useCustomSnak();
  const [csvIsLoading, setCsvIsLoading] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [pageState, setPageState] = useState<PageState>(defaultPageState);
  const [searchValue, setSearchValue] = useState<string>('');
  const [topFormState, setTopFormState] = useState<TopFormState>({
    dealershipId: 0,
    endDate: null,
    searchInput: '',
    searchType: searchOptions[0],
    startDate: null,
    statusSelection: undefined,
    timeSearchType: timestampTypeSearchOption[0]
  });
const [showConfirmationModal, setShowConfirmationModal] = useState(false);
const [pendingInvoiceUpdate, setPendingInvoiceUpdate] = useState<PendingUpdate | null>(null);
const [showInvoiceMergeConfirmation, setShowInvoiceMergeConfirmation] = useState(false)
const [selectedInvoices, setSelectedInvoices] = useState<any[]>([]);
const [isPayNowMode, setIsPayNowMode] = useState(false);
const allowedStatusesForPayNow = ["missing_cc_token", "Declined"];

const toggleRow = (rowObj: any) => {
  setSelectedInvoices((prev) =>
    prev.some((item) => item.id === rowObj.id)
      ? prev.filter((item) => item.id !== rowObj.id)
      : [...prev, rowObj]
  );
};
const togglePage = (checked: boolean) => {
  const pageObjects = invoices;
  setSelectedInvoices((prev) => {
    if (checked) {
      const newSelection = [...prev];
      pageObjects.forEach((obj) => {
        if (!newSelection.some((item) => item.id === obj.id)) {
          newSelection.push(obj);
        }
      });
      return newSelection;
    } else {
      return prev.filter((item) => !pageObjects.some((obj) => obj.id === item.id));
    }
  });
};
  // fetch stuff //////////////////////////////////////////////////////////////
  // invoices
  const [[invoices, totalInvoicesCount], setContracts] = React.useState<[Invoice[], number]>([[], 0]);
  const searchInvoices = async (): Promise<void> => {
    setIsLoading(true);
    const response = await getInvoices();
    setContracts([response.body, response.totalRecordCount]);
    setIsLoading(false);
  }

  // handlers /////////////////////////////////////////////////////////////////
  const handleCsvButton = async (): Promise<void> => {
    setCsvIsLoading(true);
    const response = await getInvoices(false, { headers: { accept: 'text/csv' }, responseType: 'text' });
    // fileDownload(response, 'data.csv');
    const currentDate = moment().format('YYYYMMDD-hhmmss')
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(response);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, "InvoiceSummary" + currentDate + fileExtension);
    setCsvIsLoading(false);
  };


  const handleTableFetchData = (state: {
    page: number;
    pageSize: number;
    sorted: SortingRule[];
  }): void => {
    setPageState({
      ...pageState,
      page: state.page,
      pageSize: state.pageSize,
      sortingRules: state.sorted,
    });
  };

  const getInvoices = async (paginate: boolean = true, apiInit: any = {}): Promise<any> => {
    const queries: Array<{ name: string; value: string }> = [];
    if (paginate) {
      queries.push({ name: 'limit', value: `${pageState.pageSize}` });
      queries.push({ name: 'offset', value: `${pageState.pageSize * pageState.page}` });
    }

    if (topFormState.dealershipId !== 0)
      queries.push({ name: 'contract.dealershipid', value: `${topFormState.dealershipId}` });
    if (topFormState.statusSelection != null)
      queries.push({ name: 'status', value: topFormState.statusSelection.value });
    if (topFormState.searchType.value !== '' && topFormState.searchInput.trim() !== '')
      queries.push({
        name: topFormState.searchType.value,
        value: topFormState.searchInput.trim(),
      });
    if (topFormState.endDate != null){
      const end_filter = topFormState.timeSearchType?.value == 'attempted_charge_time'  ? 'lt-attempted_charge_date' : 'lt-insertedtimestamp'
      queries.push({ name: end_filter, value: moment(topFormState.endDate).format('YYYY-MM-DD').toString() });
    }
     
    if (topFormState.startDate != null){
      const start_filter = topFormState.timeSearchType?.value == 'attempted_charge_time' ? 'gte-attempted_charge_date' : 'gte-insertedtimestamp'
      queries.push({ name: start_filter, value: moment(topFormState.startDate).format('YYYY-MM-DD').toString() });
    }
    // sort
    let i: number = 0;
    for (let sortingRule of pageState.sortingRules)
      queries.push({
        name: `orderBy-${i++}${sortingRule.desc === true ? '-desc' : ''}`,
        value: `${sortingRule.id}`,
      });

    let path: string = '/invoices';
    if (queries.length >= 1) {
      const paramStrings: string[] = queries.map(q => `${encodeURIComponent(q.name)}=${encodeURIComponent(q.value)}`);
      path = `${path}?${paramStrings.join("&")}`;
    }

    try {
      return await API.get(getAPIName(), path, apiInit);
    } catch (e) {
      handleApiErrors(e, enqueueSnackbar);
    }
  };

  // JSX.Element preprocessing /////////////////////////////////////////////////
  let pages: number =
    totalInvoicesCount === 0 || pageState.pageSize === 0
      ? 0
      : Math.trunc(totalInvoicesCount / pageState.pageSize);
  if (
    pages > 0 &&
    totalInvoicesCount > pageState.pageSize &&
    totalInvoicesCount % pageState.pageSize > 0
  )
    ++pages;
  const classes = useButtonStyles();
  const [editInvoiceStatFlag, setEditInvoiceStatFlag] = useState(false)
  const [invoiceToEdit, setInvoiceToEdit] = useState({})
  const [updatedInvoiceStatus, setUpdatedInvoiceStatus] = useState('')
  const [updateExecuted, setUpdateExecuted] = useState(false)
  const [editTabIndex, setEditTabIndex] = useState(0);
  
  const editInvoiceStatus = (invoice: Invoice, tabIndex: number = 0) => {
    setEditInvoiceStatFlag(true)
    setInvoiceToEdit(invoice)
    setUpdatedInvoiceStatus(invoice.status)
    setEditTabIndex(tabIndex)
  }
  const toggleInvoiceEditPopup = () => {
    setEditInvoiceStatFlag(!editInvoiceStatFlag);
  }
  const handlePaymentLinkReactivation = async (paymentLinkId : string) =>{
    try {
      setIsLoading(true)
      let path = '/api/v1/paymentlink/' + paymentLinkId;
      const response: any = await API.patch(getAPIName(), path,
        {
          body: {"active":"true"}
        });
      handleCustomSnak(`PaymentLink has been reactivated`, 'success')
      setIsLoading(false)
      setUpdateExecuted(!updateExecuted)
    }
    catch (e) {
      handleApiErrors(e, enqueueSnackbar);
      setIsLoading(false)
    }
  }
  const columns: Column[] = [
    ...(isPayNowMode ?
      [{
        id: "checkbox",
        accessor: "",
        Header: () => {
          const pageIds = invoices.map((row) => row.id);
          const allPageSelected = pageIds.every((id) =>
            selectedInvoices.some((item) => item.id === id)
          );
          const somePageSelected = pageIds.some((id) =>
            selectedInvoices.some((item) => item.id === id)
          );
          return (
            <input
              type="checkbox"
              ref={(el) => {
                if (el) el.indeterminate = !allPageSelected && somePageSelected;
              }}
              checked={allPageSelected}
              onChange={(e) => togglePage(e.target.checked)}
            />
          );
        },
        Cell: ({ original }: { original: any }) => {
          if (!original) return null;
          const isChecked = selectedInvoices.some((item) => item.id === original.id);
      
          return (
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => toggleRow(original)}
            />
          );
        },
        sortable: false,
        width: 45,
      }]
      : []),
    {
      Header: 'Invoice Number',
      accessor: 'id',
      Cell: (props: any) => {
        return props.original.bucketpath && (
          <a
            target="_blank"
            href={
              'https://tollaid-emailtemplates.s3.us-east-2.amazonaws.com/prod/' +
              props.original.bucketpath
            }
          >
            {props.original.id}
          </a>
        )
      },
      width: 90,
    },
    {
      Header: 'Contract #',
      accessor: 'contract.contractnumber',
      width: 80,
    },
    {
      Header: 'RO #',
      accessor: 'contract.ro_number',
      width: 60, 
    },
    {
      Header: 'First Name',
      accessor: 'contract.customer.firstname',
      width: 100, 
    },
    {
      Header: 'Last Name',
      accessor: 'contract.customer.lastname',
      width: 100, 
    },
    {
      Header: 'Email',
      accessor: 'contract.customer.emailaddress',
      Cell: (props: any) => {
        const email = props.original.contract?.customer?.emailaddress;
        const isValid = props.original.contract?.customer?.is_valid;
        const tooltipText = isValid === true ? "Email Validated" : isValid === false ? "Email Undeliverable" : "";
        return email ? (
          <div style={{cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center'}}>
            {isValid == false && (
              <FontAwesomeIcon
                style={{ color: '#888', marginRight: 3, cursor: 'pointer', marginTop: '3px' }}
                icon={faExclamationCircle}
                size="sm"
                onClick={() => editInvoiceStatus(props.original, 1)}
              />
            )}
            {isValid !== null && isValid !== undefined ? (
              <Tooltip title={tooltipText}>
                <span>{email}</span>
              </Tooltip>
            ) : (
              <span>{email}</span>
            )}
          </div>
        ) : '-';
      },
      width: 180,
    },
    {
      Header: 'Amount',
      id: 'amount',
      width: 80, 
      Cell: (props: any) => {
        return props.original.amount != null ?
            (
                props.original.bucketpath && (
                    <a href={'https://tollaid-emailtemplates.s3.us-east-2.amazonaws.com/prod/' + props.original.bucketpath}
                        target="_blank" rel="noopener noreferrer"
                        style={{ backgroundColor: 'lavender', border: '1px solid #e3c8ef', color: 'blue', padding: '5px', fontSize: '12px', textDecoration: 'none', borderRadius: '4px', display: 'inline-block', textAlign: 'center', width: '100%', maxWidth: '100px' }}>
                        ${(+props.original.amount).toFixed(2)}
                    </a>
                )
            ) : ('-')
      }
    },
    {
      accessor: (row: any) => row.insertedtimestamp == null
      ? '—'
      : moment(row.insertedtimestamp).local().format('MM/DD/YYYY h:mm a'),
      Header: 'Invoice Date',
      id: 'insertedtimestamp',
    },
    {
      accessor: (row: any) => row.attempted_charge_date == null
        ? '—'
        : moment(row.attempted_charge_date).local().format('MM/DD/YYYY h:mm a'),
      Header: 'Attempted Charge Date',
      id: 'attempted_charge_date',
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: (props: any) => {
        return props.original.status && (
          <div className={classes.invoice_stat_div}>
            <div className={classes.invoice_stat}>
            {
              ( props.original.contract.dealership?.lmsversion == 'TSDv2' ?  lmsLevelInvoiceStatusMapping[props.original.contract.dealership.lmsversion][props.original.status] : statusOptionsDict[props.original.status]  )
              || '-'
            }
            </div>
          </div>
        )
      }
    },
    {
      Header: 'PaymentLink Status',
      accessor: 'paymentlink',
      sortable: false,
      Cell: (props: any) => {
        const { status, paymentlink } = props.original;
        if (statusesThatNeedAttemptedDate.includes(status)) return "-";
        const mainLink = paymentlink.find((pl: any) => pl.paymentlink_identifier === 0 && pl.merged_payment == false);
        return ( mainLink?.status && status != 'Charged' ) ? ( (mainLink?.status == 'Created' && status != 'Charged')  ? (
          <Button onClick={() => window.open(mainLink?.payment_link_url)} color="primary" size="small" variant="contained" > Pay  </Button>
          ) : 
          ( mainLink?.status == 'Expired' ? 
          <Button onClick={() => handlePaymentLinkReactivation(mainLink.payment_link_id)}  size="small" variant="contained" className={classes.paymentlink_reactivation} > Reactivate  </Button>
          : mainLink.status)) 
          : "-"
      }
    },
    {
      Header: "Payment Details",
      width:140,
      Cell: (props: any) => {
        const pl = props.original.paymentlink?.[0];      
        const at = props.original.contract?.authtoken;
        const src =
          pl && pl.status === "Complete"
            ? pl
            : at
            ? at
            : null;
        return (
          <PaymentDetails 
            data={src}
            logos={PAYMENT_LOGOS}
            logoSizes={{ 
              link:{height:18, width:18},
              klarna: { width: 38, height: 21 },
            }}
          />
        );
      }
    },
    {
      Header: 'Send Mail',
      id: 'send_mail',
      width: 100,
      Cell: ({ original }: any) => {
        const customer = original.contract.customer || {};
        const name = `${customer.firstname || ''} ${customer.lastname || ''}`.trim();
        const paymentlink = original.paymentlink?.[0]?.payment_link_url ?? null
        const paymentlinkid = original.paymentlink?.[0]?.payment_link_id ?? null;
        const daysDiff = Math.floor((Date.now() - new Date(original.insertedtimestamp).getTime()) / 86400000);
        const isEscalationTime = daysDiff >= 10;
        const mailHref = generateMailHref(
          original.status,
          name,
          customer.emailaddress,
          original.contract.contractnumber,
          original.bucketpath,
          original.contract.dealership.name,
          false,
          paymentlink
        );
        const warning_mail_href = generateEscalationMailHref(
          name,
          customer.emailaddress,
          original.contract.dealership.name,
          original.bucketpath,
          paymentlink,
          original.amount,
          daysDiff
        );
        if (!mailHref || original.paymentlink.length == 0) return '-';
        const handleRegularMailClick = (e: React.MouseEvent) => {
          e.preventDefault();
          e.stopPropagation();
          if (paymentlinkid && original.paymentlink?.[0]?.status == 'Expired') {
            handlePaymentLinkReactivation(paymentlinkid);
          }
          window.open(mailHref, '_blank');
        };
        const handleEscalationMailClick = (e: React.MouseEvent) => {
          if (!isEscalationTime) return;
          e.preventDefault();
          e.stopPropagation();
          if (paymentlinkid && original.paymentlink?.[0]?.status == 'Expired') {
            handlePaymentLinkReactivation(paymentlinkid);
          }
          window.open(warning_mail_href, '_blank');
        };
        return (
          <div className={classes.splitMailContainer}>
            {/* Regular Mail */}
            <Tooltip title="Send Regular Mail" arrow>
              <div 
                className={`${classes.mailSection} ${classes.regularSection}`}
                onClick={handleRegularMailClick}
              >
                <div className={classes.mailContent}>
                  <FontAwesomeIcon icon={faPaperPlane} className={classes.mailIcon} />
                </div>
              </div>
            </Tooltip>
            {/* Escalation Mail */}
            <Tooltip title="Send Escalation Mail" arrow>
              <div 
                className={`${classes.mailSection} ${classes.escalationSection}`}
                onClick={handleEscalationMailClick}
                style={{
                  opacity: !isEscalationTime ? 0.5 : 1,
                  cursor: !isEscalationTime ? 'not-allowed' : 'pointer'
                }}
              >
                <div className={classes.mailContent}>
                  <FontAwesomeIcon icon={faCircleExclamation} className={classes.mailIcon} />
                </div>
              </div>
            </Tooltip>
            <div className={classes.slideIndicator}></div>
          </div>
        );
      }
    },
    {
      Header: 'Dealership',
      accessor: 'contract.dealership.name'
    },
    {
      Header: 'Group',
      accessor: 'contract.dealership.dealershipgroup.name'
    },
    {
      Header: 'Payment Gateway Fee',
      accessor: 'pgw_fee_total',
      width: 60, 
    },
    {
      accessor: "invoiceinformation.comment",
      sortable: false,
      Header: 'Notes',
      width: 60, 
      Cell: (props: any) => props.original.invoiceinformation?.comment ? props.original.invoiceinformation.comment : '-'
    },
    {
      Header: 'Edit',
      id: 'edit',
      sortable: false,
      Cell: (props: any) => {
        return (
          < Button
            variant="outlined"
            onClick={() => editInvoiceStatus(props.original)}
          >
            <FontAwesomeIcon icon={faPencilAlt} />
          </Button>
        )
      }
    }
  ];
  const statusesThatNeedAttemptedDate = ['manually_refunded', 'manually_charged'];
  const updateInvoice = async (invoice: any, updated_status: string): Promise<void> => {
    let apiName = getAPIName();
    let path = `/invoices`;
    try {
      var current_session_data = await Auth.currentAuthenticatedUser();
      var user_name = null
      if (current_session_data.attributes.name || current_session_data.attributes.email) {
        user_name = current_session_data.attributes.name || current_session_data.attributes.email
      }
    const body:Record<string, any> = {
      status: updated_status,
      updated_by: user_name,
    };
    if (statusesThatNeedAttemptedDate.includes(updated_status)) {
      body.attempted_charge_date = new Date().toISOString();
    }
      const response = await API.patch(apiName, path + "/" + invoice.id, {body});
      if (response.body[1] > 0) {
        enqueueSnackbar('invoice changes saved!', { variant: 'success' });
      }
      else {
        handleApiErrors("cannot update the status", enqueueSnackbar, 'invoice')
      }
      setUpdateExecuted(!updateExecuted)
      toggleInvoiceEditPopup();
      setInvoiceToEdit({})
    } catch (e) {
      handleApiErrors(e, enqueueSnackbar, 'invoice');
    }
  };
const handleSaveWithConfirmation = (invoice: any, updated_status: string) => {
  if (statusesThatNeedAttemptedDate.includes(updated_status)) {
    setPendingInvoiceUpdate({ invoice, updated_status });
    setShowConfirmationModal(true);
  } else {
    updateInvoice(invoice, updated_status);
  }
};

const handleConfirmationResponse = (confirmed: boolean) => {
  if (confirmed && pendingInvoiceUpdate) {
    updateInvoice(pendingInvoiceUpdate.invoice, pendingInvoiceUpdate.updated_status);
    setEditInvoiceStatFlag(false);
  } 
  else {
    setEditInvoiceStatFlag(true);
  }
  setShowConfirmationModal(false);
  setPendingInvoiceUpdate(null);
};

const handleInvoiceCombineConfirm = async() => {
  let apiName = getAPIName();
  let path = `/api/v1/paymentlink/combine`;
  try {
  const hasInvalidStatus = selectedInvoices.some(
    (e:any) => !allowedStatusesForPayNow.includes(e.status)
  );
  if (hasInvalidStatus) {
    return handleCustomSnak(`Invalid invoice selected`, 'error')
  }
  const body = selectedInvoices.map((e:any)=> (
    {
    "invoiceid": e.id ,
    "amount": parseFloat(e.amount) || 0,
    "contractNumber":  e.contract.contractnumber 
    }
  ))
    const response = await API.post(apiName, path, {body});
    if (response?.success && response?.paymentLink?.url) {
      setSelectedInvoices([])
      setIsPayNowMode(false)
      return response.paymentLink.url;
    }
    else {
      handleApiErrors("Failed to create paymentlink", enqueueSnackbar, 'invoice')
    }
  } catch (e) {
    handleApiErrors(e, enqueueSnackbar, 'invoice');
  }
}

  useEffect(() => { searchInvoices(); }, [searchValue, pageState, updateExecuted]);

  // render ///////////////////////////////////////////////////////////////////
  return (
    <div className="Invoices">
      {/* <AnnouncmentBanner/> */}
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item>
          <Typography variant="h4" align="left">
            Invoices
          </Typography>
        </Grid>

        <Grid item>
          <Box display="flex" alignItems="center">
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={() => navigate('/subscriptioninvoice')}
              style={{ marginRight: '1rem' }}
            >
              Subscription Invoices
            </Button>

            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={handleCsvButton}
              style={{ marginRight: '1rem' }}
            >
              {!csvIsLoading ? 'Download Excel' : <CircularProgress size={24} />}
            </Button>

            <Button
              size="small"
              variant="contained"
              style={{
                backgroundColor: isPayNowMode ? '#d32f2f' : 'forestgreen',
                color: '#fff',
                minWidth: '100px',
              }}
              onClick={() => setIsPayNowMode(!isPayNowMode)}
            >
              {isPayNowMode ? 'Cancel' : 'Pay Now'}
            </Button>
          </Box>
        </Grid>
      </Grid>

      <TopForm
        onChange={setTopFormState}
        onSearch={searchInvoices}
        searchOptions={searchOptions}
        state={topFormState}
        statusOptions={statusOptions}
        timestampTypeSearchOption={timestampTypeSearchOption}
        numericFields={['id']}
      />

      <Grid container>
        <Grid xs={12}>
          <ReactTable
            className="-striped -highlight"
            columns={columns}
            data={invoices}
            defaultPageSize={10}
            defaultSorted={defaultPageState.sortingRules}
            loading={isLoading}
            manual
            onFetchData={handleTableFetchData}
            pages={pages}
          />
        </Grid>
      </Grid>
      {
        isPayNowMode &&
        <Grid container justifyContent="center" style={{ padding: "16px 0" }}>
          <Button
            size="small"
            variant="contained"
            style={{
              backgroundColor: selectedInvoices.length <= 1 ? '#ccc' : 'forestgreen',
              color: selectedInvoices.length <= 1 ? '#666' : '#fff',
              minWidth: '100px'
            }}
            disabled={selectedInvoices.length > 1 ? false : true}
            onClick={() => setShowInvoiceMergeConfirmation(true)}
          >
            CHECKOUT
          </Button>
        </Grid>
      }
      <EditInvoicePopup
        invoice={invoiceToEdit}
        isOpen={editInvoiceStatFlag}
        text="Edit Invoice"
        handleSave={handleSaveWithConfirmation}
        toggleOpen={toggleInvoiceEditPopup}
        updatedInvoiceStatus={updatedInvoiceStatus}
        setUpdatedInvoiceStatus={setUpdatedInvoiceStatus}
        updateExecuted={updateExecuted}
        setUpdateExecuted={setUpdateExecuted}
        customerEdit = {true}
        notesEdit = {true}
        showLastUpdatedBy={true}
        defaultTab={editTabIndex}
      />
      <ConfirmationModal
        open={showConfirmationModal}
        title="Confirm Status Change"
        message="You cannot revert back from this status. Are you sure you want to proceed?"
        onConfirm={() => handleConfirmationResponse(true)}
        onCancel={() => handleConfirmationResponse(false)}
        confirmButtonText="Yes, Proceed"
        cancelButtonText="Cancel"
        showWarningIcon={true}
        confirmButtonColor="#4caf50"
        maxWidth="sm"
      />

      <GeneralisedConfirmationPopup
        isOpen={showInvoiceMergeConfirmation}
        toggleOpen={() => setShowInvoiceMergeConfirmation(false)}
        confirmedAction={handleInvoiceCombineConfirm}
        title="Payment"
        message="You are about to make payment for following invoices."
        showAsTable={true}
        presentResult={true}
        data={selectedInvoices.map(e => ({
          invoiceId: e.id,
          amount: e.amount,
          status: statusOptionsDict[e.status],
          contractNumber: e.contract.contractnumber ? e.contract.contractnumber : "N/A",
          vehicle: (e.contract.vehicle?.licenseplate ?? "") + "-" + (e.contract.vehicle?.state ?? ""),
          customer_info: (e.contract.customer?.firstname ?? "") + " " + (e.contract.customer?.lastname ?? ""),
        }))}
        headers={{
          invoiceId: "Invoice Id",
          contractNumber: "RA / Contract Number",
          customer_info: "Customer Name",
          vehicle: "License Plate",
          amount: "Amount",
          status: "Status",
        }}
        onRemoveItem={(index, row) => {
          setSelectedInvoices((prev) => prev.filter((_, i) => i !== index));
        }}
        total_display={{
          label: "Total",
          value: selectedInvoices
            .reduce((sum, e) => sum + (parseFloat(e.amount) || 0), 0)
            .toFixed(2)
        }}
      />
    </div>
  );
}

